// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"d8841d4d","147":"f6309eb6","533":"4b90dc20","705":"b3f9627f","731":"32fb7fc2"}[chunkId] + ".chunk.js";
};